import React, { useContext } from 'react';
import { MainNavbar } from './navbar';
import { Accounts } from './accounts';
import { HomePage } from './home';
import { AppContext } from '../App';
import { QuickLinks } from './quick_links';
import { Enquiry } from './enquiry';
export const Dashboard=()=>{
	const { page } = useContext(AppContext);
	

	return(
		<div className="dashboard-wraper">
			<MainNavbar />
			{
				page!==undefined?(
					page === 'accounts'?(
					<Accounts />
					):page==='home'?(
					<HomePage />
					):page==='quick_links'?(
					<QuickLinks />
					):page==='enquiry'?(
					<Enquiry />
					):''
				):''
			}
	    </div>
		)
}